import { getConfig } from '@/configProvider';
import eventBus from '@/utils/eventBus';
import { createTransferId, priceCalculate, PriceCalculateParams } from '../services';

// 用于等待二次确认
export let processingConfirm: any = () => {};

/**
 * 打开美豆充值页面
 */
export const openSubscribe = (firstSource?: string, second_source?: string, vipParams?: Record<string, any>) => {
    eventBus.emit('xdesign-widgets__meidouInfo', {
        openSubscribe: true,
        firstSourceFromOther: firstSource,
        second_source,
        vipParams,
    });
};

/**
 * 获取是否需要二次确认
 */
export const checkConfirmStatus = async (val?: number) => {
    const stauts = window.localStorage.getItem('xdesign-widgets__meidouInfo__agreement-status') || '2';

    // 是否已经勾选静默扣美豆。1=是；2=否
    if (+stauts === 2 && val) {
        eventBus.emit('xdesign-widgets__meidouInfo', {
            showConfirm: true,
            consumeNum: val,
        });
        // 等待确认
        return await new Promise((resolve) => (processingConfirm = resolve));
    }
    return stauts;
};

/**
 * 获取算价结果
 * @param params 算价任务的入参
 * @param id 算价对应的按钮id，如果不传就默认更新所有 <Gen/> 按钮文案
 */
export const getCalculatePrice = async (
    params: Pick<PriceCalculateParams, 'subfunc' | 'task_param' | 'num' | 'need_free' | 'education_role'>,
    id?: string,
    hideStringify?: boolean,
    // 新增 v2 策略兼容
    isFreeV2?: boolean,
    needFree?: boolean,
) => {
    const { client_id, country_code } = getConfig();
    const res = await priceCalculate(
        { ...params, client_id, country_code, ignore_login: true },
        hideStringify,
        isFreeV2,
        needFree,
    );

    let data = undefined;
    if (res.data?.code === 0) {
        data = res.data.data || {};
        // data = {
        //   type: 2,
        //   price: 3,
        //   payment_amount: 0,
        //   available_amount: 2,
        //   total_amount: 0,
        //   left_num: 5,
        //   free_num: 5,
        //   success: true,
        //   message: '有限免资格',
        // };
    }

    eventBus.emit('xdesign-widgets__meidouInfo__calc-price', {
        id: id || '',
        data,
    });
};

export const getOperSystem = () => {
    // 操作系统：0-未知 1-Android、2-AndroidPad、3-iOS、4-Windows、5-Linux、6-iPadOS、7-macOS
    let oper_system = 0;
    if (/Android/i.test(navigator.userAgent) && !/Tablet/i.test(navigator.userAgent)) {
        // AndroidPad操作系统
        oper_system = 1;
    } else if (/Android/i.test(navigator.userAgent) && /Tablet/i.test(navigator.userAgent)) {
        // AndroidPad操作系统
        oper_system = 2;
    } else if (/iOS/i.test(navigator.userAgent)) {
        // iOS操作系统
        oper_system = 3;
    } else if (/Windows/i.test(navigator.userAgent)) {
        // Windows操作系统
        oper_system = 4;
    } else if (/Linux/i.test(navigator.userAgent)) {
        // Linux操作系统
        oper_system = 5;
    } else if (/iPad/i.test(navigator.userAgent)) {
        // iPadOS
        oper_system = 6;
    } else if (/Macintosh|Mac OS X/i.test(navigator.userAgent)) {
        // macOS操作系统
        oper_system = 7;
    }
    return oper_system;
};

export const getDeviceType = async () => {
    const { clientInfo } = (await import('@meitu/pc-bridge')).default;

    return clientInfo.isClient ? 2 : 3;
};

export const getOperaSystem = () => {
    // 操作系统：0-未知 1-Android、2-AndroidPad、3-iOS、4-Windows、5-Linux、6-iPadOS、7-macOS
    let oper_system = 0;
    if (/Android/i.test(navigator.userAgent) && !/Tablet/i.test(navigator.userAgent)) {
        // AndroidPad操作系统
        oper_system = 1;
    } else if (/Android/i.test(navigator.userAgent) && /Tablet/i.test(navigator.userAgent)) {
        // AndroidPad操作系统
        oper_system = 2;
    } else if (/iOS/i.test(navigator.userAgent)) {
        // iOS操作系统
        oper_system = 3;
    } else if (/Windows/i.test(navigator.userAgent)) {
        // Windows操作系统
        oper_system = 4;
    } else if (/Linux/i.test(navigator.userAgent)) {
        // Linux操作系统
        oper_system = 5;
    } else if (/iPad/i.test(navigator.userAgent)) {
        // iPadOS
        oper_system = 6;
    } else if (/Macintosh|Mac OS X/i.test(navigator.userAgent)) {
        // macOS操作系统
        oper_system = 7;
    }
    return oper_system;
};

/**
 * 获取transfer_id
 * @param params 自定义入参
 * @returns
 */
export const getTransferId = async (
    params: {
        source: string;
        [key: string]: any;
    },
    hideStringify?: boolean,
) => {
    const { gid, device_id, channel, country_code, app_key, module_id } = getConfig();
    const deviceType = await getDeviceType();
    const operSystem = getOperSystem();
    const base_data = {
        oper_system: operSystem,
        device_type: deviceType, // 终端类型：0-未知、1-app、2-pc、3-web
    };
    const big_data = {
        gid,
        device_id,
        channel,
        country_code,
        app_key,
        order_type: 4, // 订单类型(1:非续期订阅 2:续期订阅 3:非消耗品 4:消耗品)
        module_id,
        oper_system: operSystem,
        device_type: deviceType,
        ...(params || {}),
    };
    const business_data = {};

    try {
        const res = await createTransferId(
            {
                base_data: JSON.stringify(base_data),
                big_data: JSON.stringify(big_data),
                business_data: JSON.stringify(business_data),
            },
            hideStringify,
        );

        if (res.data?.code === 0) {
            return res.data.data?.transfer_id || '';
        }
        return '';
    } catch (e) {
        return '';
    }
};

/**
 * 通过module_id  匹配 接口所需的ai 模块id
 * @param moduleId
 * @returns
 */

export const getAIModule = (moduleId: string) => {
    const map: { [key: string]: string } = {
        aispt: 'ai_product',
        aimodel: 'ai_model',
        znhz: 'ai_model',
        aishoedesign: 'ai_shoes',
        aippt: 'ai_ppt',
        aihuazi: 'ai_figure_text',
    };
    return map[moduleId] || '';
};

export const getTokenKey = () => {
    return getConfig().silent_token_key || 'access_token';
};
